module.exports = "<h1>PRODUCT222222</h1>\r\n<button mat-raised-button color=\"primary\" (click)=\"agregarProductoVenta02()\">\r\n    aaaaa\r\n</button>"